import logo from "./logo.svg";
import "./App.css";
import { Helmet } from "react-helmet";
import Map from "./Map";

function App() {
  return (
    <div className="App">
      <Helmet>
        <title>Christkindlmarkts</title>
        <meta
          name="description"
          content="Welcome to the home page of My Website."
        />
      </Helmet>
      <Map />
    </div>
  );
}

export default App;
